import React, { useEffect, useState } from "react";
import {
  Content,
  Row,
  Col,
  Box,
  SimpleTable,
  Pagination,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../utils/Loader";
import moment from "moment";

function SugerenciasList({ history, match }) {
  const dispatch = useDispatch();

  const modelSugerencias = useSelector((state) => state.sugerencias);

  const [sugerencias, setSugerencias] = useState([]);
  const [totalResults, setTotalResults] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    const data = modelSugerencias?.data?.data;
    const error = modelSugerencias?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckSugerencias.actions.clear());
    }
    if (data) {
      setSugerencias(data.data.items);
      setTotalResults(data.data.total);

      dispatch(controller.duckSugerencias.actions.clear());
    }
  }, [modelSugerencias]);

  useEffect(() => {
    dispatch(controller.getSugerenciasThunk(1, pageSize));
  }, []);

  function handlePage(page) {
    setActivePage(page);
    setSugerencias([]);
    dispatch(controller.getSugerenciasThunk(page + 1, pageSize));
  }

  return (
    <Content
      title="Sugerencias"
      subTitle="Sugerencias"
      browserTitle="Sugerencias"
      show={false}
    >
      <Row>
        <Col md="10" mdOffset="1">
          <Box title="Sugerencias">
            <div>
              <span>Total: {totalResults}</span>
            </div>
            <Loader isLoading={modelSugerencias.loading}>
              {sugerencias && sugerencias.length > 0 ? (
                <SimpleTable
                  hover={true}
                  data={sugerencias.map((row, index) => {
                    return {
                      nombre: row.sugerencia,
                      telefono: row.telefono,
                      direccion: row.direccion,
                      fecha: moment(row.ts, "YYYY-MM-DD").format(
                        "DD-MM-YYYY"
                      ),
                      usuario: row.userId,
                    };
                  })}
                  columns={[
                    { title: "Nombre", data: "nombre" },
                    { title: "Telefono", data: "telefono" },
                    { title: "Direccion", data: "direccion" },
                    { title: "Fecha", data: "fecha" },
                    { title: "Sugerido por", data: "usuario" },
                  ]}
                />
              ) : (
                <h4>No se han encontrado sugerencias</h4>
              )}
            </Loader>
            <Pagination
              activePage={activePage}
              pageSize={pageSize}
              totalElements={totalResults}
              onChange={handlePage}
              labels={{
                first: "Primera",
                last: "Última",
                previous: "Anterior",
                next: "Siguiente",
              }}
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default SugerenciasList;
